/**
 * A textarea that auto-resizes like a div
 * 
 * Will work best when one dimension is fixed (eg. full-width)
 * Uses a hidden p tag to determine the dimensions, and renders the textarea on top.
 * If all goes well the text in the textarea and the p should match perfectly.
 * 
 * Must supply "value" back so that it knows what text is inside itself to render the p.
 */
export default function TextareaAutoResize({className, name, placeholder, required, disabled, onChange, value, inputRef}){
    return (
        <div className={`relative ${className || ''}`}>
            <p className="whitespace-pre-wrap w-full break-word text-left overflow-scroll p-4 opacity-0">{value || "empty"}&nbsp;</p>
            <textarea
                id={name}
                name={name}
                placeholder={placeholder}
                className={"absolute inset-0 overflow-scroll p-4 resize-none"}
                onChange={onChange}
                required={required}
                disabled={disabled}
                value={value}
                ref={inputRef}
            />
        </div>
    )
    
}